import React from "react";

import { colors } from "../../../utils/Colors";
import { Styles } from "./footer";

import { Link, useNavigate } from "react-router-dom";
import RoutesPath from "../../../utils/Paths";
import { useSelector } from "react-redux";

import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTiktok,
  FaWhatsapp,
  FaYoutube,
} from "react-icons/fa";
import AppleStoreButton from "../../../assets/images/Apple_Store.png";
import FalconLogo from "../../../assets/images/falcon-horizental.png";
import GooglePlayButton from "../../../assets/images/Google_Play.png";
// import HowItWorksJpeg from "../../../assets/images/how-it-works.jpeg";
import HowItWorksJpeg from "../../../assets/images/How-to-Get-Starte-updated.jpeg";

import ImagePreview from "../ImagePreview";
import playBadge from "../../../assets/images/google-play-badge.svg";
import appleBadge from "../../../assets/images/app-store-badge.svg";

const Footer = () => {
  const [modal, setModal] = React.useState(false);
  const toggle = () => setModal(!modal);
  const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };
  const { categories } = useSelector((state) => state.categories);
  // Show up to 8 categories as SEO links in the footer
  const topCategories = (categories || []).slice(0, 8);

  const navigate = useNavigate();
  return (
    <>
      <ImagePreview
        imageUrl={HowItWorksJpeg}
        isOpen={modal}
        onClose={toggle}
        fullScreen={true}
        // Keep this wide infographic fully inside the viewport.
        // NOTE: a percentage max-height would resolve against the frame, whose
        // own height is `auto` (indefinite) -- so the browser would ignore it and
        // the image would overflow. Viewport units are always definite.
        // 32px = the backdrop's 16px top + bottom padding.
        containerStyle={{ maxHeight: "calc(100vh - 32px)", minHeight: 0 }}
        imageStyle={{
          display: "block",
          maxWidth: "100%",
          maxHeight: "calc(100vh - 32px)",
          width: "auto",
          height: "auto",
          objectFit: "contain",
        }}
      />
      <Styles colors={colors}>
        <div className="footer-section">
          <div className="about">
            <div className="logo-text">
              <img
                onClick={() => navigate("/")}
                style={{ cursor: "pointer" }}
                src={FalconLogo}
                alt="Logo"
                className="logo-icon"
              />
              <span className="below-text" style={{ fontFamily: '"MS_Bold", "Arial Black", sans-serif' }}>Where Every Skill Counts!</span>
            </div>

            <div className="contactInfo">
              <div className="social-icons">
                <FaFacebook
                  className="facebook-icon"
                  onClick={() =>
                    openInNewTab(
                      "https://www.facebook.com/profile.php?id=61556146895847"
                    )
                  }
                />
                <FaInstagram
                  className="instagram-icon"
                  onClick={() =>
                    openInNewTab("https://www.instagram.com/gigfalcon01/")
                  }
                />
                <FaWhatsapp
                  className="whatsapp-icon"
                  onClick={() =>
                    openInNewTab(
                      "https://whatsapp.com/channel/0029VacpJyl3rZZhni2d5q0K"
                    )
                  }
                />
                <FaYoutube className="youtube-icon"
                  onClick={() =>
                    openInNewTab(
                      "https://www.youtube.com/@gigfalcon7422"
                    )
                  }
                />
                <FaLinkedin className="linkedin-icon"
                  onClick={() =>
                    openInNewTab(
                      "https://www.linkedin.com/company/gigfalcon/"
                    )
                  }
                />
                <FaTiktok className="tiktok-icon"
                  onClick={() =>
                    openInNewTab(
                      "https://www.tiktok.com/@gigfalcon"
                    )
                  }
                />
              </div>
              {/* <span>Contact us:</span> */}
              {/* <span>support@gigfalcon.com</span> */}
            </div>
          </div>
          <div className="support">
            <Link onClick={toggle} style={{ fontFamily: '"MS_Bold", "Arial Black", sans-serif' }}>{"How it Works"}</Link>
            <Link to={RoutesPath.subscriptionPlans} style={{ fontFamily: '"MS_Bold", "Arial Black", sans-serif' }}>{"Employer Pricing"}</Link>
            <Link to={RoutesPath.legalTOS} style={{ fontFamily: '"MS_Bold", "Arial Black", sans-serif' }}>{"Terms of Service"}</Link>
            <Link to={RoutesPath.legalPTOS} style={{ fontFamily: '"MS_Bold", "Arial Black", sans-serif' }}>{"Payments Terms of Service"}</Link>
            <Link to={RoutesPath.legalNDP} style={{ fontFamily: '"MS_Bold", "Arial Black", sans-serif' }}>{"Non-Discrimination Policy"}</Link>
            <Link to={RoutesPath.legalPP} style={{ fontFamily: '"MS_Bold", "Arial Black", sans-serif' }}>{"Privacy Policy"}</Link>
          </div>
          <div className="community">
            <a
              href="mailto:support@gigfalcon.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{ fontFamily: '"MS_Bold", "Arial Black", sans-serif' }}
            >
              support@gigfalcon.com
            </a>
          </div>
          <div className="newsletter">
            <div className="d-flex flex-column gap-3 footer-app-icons">
              <img
                onClick={() =>
                  openInNewTab(
                    "https://play.google.com/store/apps/details?id=com.gigfalcon"
                  )
                }
                style={{ cursor: "pointer" }}
                src={playBadge}
                alt="GooglePlay"
                className="play-icon"
              />
              <img
                onClick={() =>
                  openInNewTab(
                    "https://apps.apple.com/us/app/gig-falcon/id6499023603"
                  )
                }
                style={{ cursor: "pointer" }}
                src={appleBadge}
                alt="AppleStore"
                className="apple-icon"
              />
            </div>
          </div>
        </div>
        <div className="borderTop"></div>
        <p className="copyright" style={{ fontFamily: '"MS_Bold", "Arial Black", sans-serif' }}>GigFalcon &copy; All Rights Reserved</p>
      </Styles>
    </>
  );
};
export default Footer;
